<template lang="pug">
  rc-modal(v-if="establishments && establishments.length" width="80em")
    .add-establishments-modal(v-rc-loader="loading")
      .establishment-summary
        .title-block
          .title {{ establishment._name }}
          .subtitle Les établissements suivants vont être fusionnés avec l'établissement :
        establishment-list(:establishments="establishments")
      .actions
        button.cancel-btn(@click="close") Annuler
        button.confirm-btn(@click="merge") Valider
</template>

<script>
import EstablishmentList from '@/components/establishment-list/EstablishmentList.vue';
import RcModal from '@/components/RcModal.vue';
import establishmentService from '@/services/establishments.js';
import { rcLoader } from '@/directives/rc-loader/rcLoader.js';

export default {
  directives: { rcLoader },
  components: {
    EstablishmentList,
    RcModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      establishments: null,
      loading: false,
    };
  },
  methods: {
    close() {
      this.establishments = null;
    },
    async merge() {
      this.loading = true;
      await establishmentService.merge(this.establishment.id, this.establishments.map(it => it.id));
      this.$emit('merge');
      this.close();
      this.loading = false;
    },
  },
}
</script>

<style lang="scss">
  .add-establishments-modal {
    .title-block {
      margin-bottom: 1em;
      text-align: center;
      .title {
        font-size: 32px;
        margin-bottom: .5em;
      }
      .subtitle {
        font-size: 20px;
        color: #8A8A8A;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 1em;
      button {
        margin: .5em;
      }
      .cancel-btn {
        background: #393939;
      }
    }
  }
</style>

